import { AppError } from './chunk-AR63MRLK.mjs';
import { Provider, ErrorBoundary as ErrorBoundary$1 } from '@rollbar/react';
import { jsx } from 'react/jsx-runtime';

var ErrorBoundary = (props) => {
  const { children, config, FallbackComponent } = props;
  return /* @__PURE__ */ jsx(Provider, { config, children: /* @__PURE__ */ jsx(
    ErrorBoundary$1,
    {
      fallbackUI: ({ error }) => {
        if (error instanceof AppError) {
          return /* @__PURE__ */ jsx(FallbackComponent, { errorMessage: error.errorMessage, canRetry: error.canRetry });
        }
        return /* @__PURE__ */ jsx(FallbackComponent, { errorMessage: "Something went wrong", canRetry: false });
      },
      children
    }
  ) });
};

export { ErrorBoundary };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-MFHL5XFY.mjs.map